import { render, staticRenderFns } from "./AllocateFromStockToOrder.vue?vue&type=template&id=346d4982&"
import script from "./AllocateFromStockToOrder.vue?vue&type=script&lang=js&"
export * from "./AllocateFromStockToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports